function pcBindGlobalEvents() {
  document.addEventListener("click", async event => {
    const target = event.target;
    if (target.closest("[data-pc-open-inventory]")) { pc$('[data-view="inventory"]')?.click(); return; }
    const reconEdit = target.closest("#pc3-reconstitution-log [data-edit-inventory]");
    if (reconEdit) { event.preventDefault(); event.stopPropagation(); pc$(`#inventory-table [data-edit-inventory="${reconEdit.dataset.editInventory}"]`)?.click(); return; }
    const add = target.closest("#add-inventory"), edit = target.closest("[data-edit-inventory]");
    if (add || edit) setTimeout(()=>pcPatchInventoryForm(edit?.dataset.editInventory || null),80);
    if (target.closest("[data-log]")) setTimeout(()=>{pcRenderRoutine();pcRenderInventoryExtras();pcRenderMonthlyReport();},120);
    if (target.closest('[data-view="settings"], [data-nav="settings"]')) setTimeout(()=>{pcRenderNotificationCenter();pcRenderDeviceTransfer();},40);
    if (target.closest('[data-view="progress"], [data-nav="progress"]')) setTimeout(pcRenderMonthlyReport,40);
    if (target.closest('[data-view="inventory"], [data-nav="inventory"]')) setTimeout(pcRenderInventoryExtras,60);
    if (target.closest("#pc3-copy-report")) pcCopyMonthlyReport();
    if (target.closest("#pc3-print-report")) pcPrintMonthlyReport();
    if (target.closest("#pc3-export-calendar")) pcExportCalendar();
    if (target.closest("#pc3-test-notification")) {
      if (!("Notification" in window)) return pcToast("Notifications are not supported here");
      let permission = Notification.permission; if (permission === "default") permission = await Notification.requestPermission();
      if (permission === "granted") { new Notification("Peptide Command",{body:"Your test reminder is working."}); pcSavePreferences({browserNotifications:true}); }
      else pcToast("Browser notification permission is not enabled");
      pcRenderNotificationCenter();
    }
    if (target.closest("#pc3-create-transfer")) pcCreateTransfer();
    if (target.closest("#pc3-restore-transfer")) pc$("#pc3-transfer-file")?.click();

    if (!pc$("#peptide-command-app") && /\/pages\/demo/.test(location.pathname)) {
      const log = target.closest("[data-log]");
      if (log?.dataset.log === "complete") { pcSetDemoCount(pcDemoCount()-1); setTimeout(pcRenderDemoGrowth,60); }
      if (log?.dataset.log === "clear") { pcSetDemoCount(pcDemoCount()+1); setTimeout(pcRenderDemoGrowth,60); }
    }
  }, true);

  document.addEventListener("change", async event => {
    const el = event.target;
    if (el.matches("#pc3-transfer-file")) { const file=el.files?.[0]; if(file) await pcRestoreTransfer(file); el.value=""; return; }
    if (!el.matches("#pc3-notification-center [data-pc-pref]")) return;
    const key = el.dataset.pcPref;
    let value = el.type === "checkbox" ? el.checked : el.value;
    if (["scheduleReminderMinutes","weeklyCheckinDay","lowSupplyThreshold","expirationLeadDays"].includes(key)) value = Number(value);
    if (key === "browserNotifications" && value) {
      if (!("Notification" in window)) { el.checked=false; return pcToast("Notifications are not supported here"); }
      const permission = await Notification.requestPermission();
      value = permission === "granted"; el.checked=value;
      if (!value) pcToast("Enable notifications in your browser settings to use this channel");
    }
    pcSavePreferences({[key]:value});
    pcToast("Notification preference saved");
    if (key === "browserNotifications") pcRenderNotificationCenter();
  });

  window.addEventListener("storage",()=>{pcRenderMemberGrowth();pcRenderDemoGrowth();});
  window.addEventListener("hashchange",()=>setTimeout(pcRenderMemberGrowth,40));
}

function pcInitGrowthV3() {
  pcBindGlobalEvents();
  pcRenderHomeGrowth(); pcRenderDemoGrowth(); pcRenderMemberGrowth(); pcCheckNotifications();
  setInterval(pcCheckNotifications,60000);
  setTimeout(()=>{ pcRenderHomeGrowth(); pcRenderDemoGrowth(); pcRenderMemberGrowth(); pcCheckNotifications(); },220);
}

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded",pcInitGrowthV3,{once:true}); else pcInitGrowthV3();
